<template>
	<div id="pushMessage">

		<div class="container">
			<!-- <div class="companyInfo">
				<div class="company_avatar">
					<img v-if="schoolInfo.logo" :src="schoolInfo.logo"></img>
					<div class="company_name" v-else>
						{{schoolInfo.company_name?schoolInfo.company_name.substring(0,1):''}}
					</div>
				</div>
				<div class="companyInfoRight">
					<div class="companyInfoName">
						{{ schoolInfo.company_name || '校招平台用户' }}
					</div>
					<div class="tags">
						<div class="item" v-if="schoolInfo.industry">
							{{schoolInfo.industry || ''}}
						</div>
						<div class="item" v-if="schoolInfo.scale">
							{{schoolInfo.scale || ''}}
						</div>
					</div>
				</div>
			</div> -->
			<div class="titleContainer">
				<div class="title1">
					社区广告
				</div>
				<div class="title2">
					将招聘信息批量推送给符合条件的学生，学生将在“消息”页面收到您的招聘邀约
				</div>

				<div class="xian">

				</div>
			</div>
		</div>

		<div class="sourceStudents">
			<div class="sourceStudentsNum">
				<div class="num1">
					<div class="title">
						剩余生源
					</div>
					<div class="numContainer">
						<div class="num">
							{{residue}}
						</div>
						<div class="unit">
							人
						</div>
					</div>
				</div>
				<div class="num2">
					<div class="title">
						已推送的生源
					</div>
					<div class="numContainer">
						<div class="num">
							{{used}}
						</div>
						<div class="unit">
							人
						</div>
					</div>
				</div>
			</div>

			<div class="selectnum">
				<div class="title">
					选择推送人数
				</div>
				<div class="selectnumMain">
					<div class="item" @click="selectNum1(0)">
						<img class="select"
							:src="isSelect==0?'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/03/03/h7axstiyrczwpifo.png':'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/03/03/vyldlkroee0e7dkr.png'"
							alt="" />
						<div class="label">
							可推送生源 200人
						</div>
						<img class="up" src="../img/selectnum.png" alt="" />
					</div>
					<div class="xian">

					</div>
					<div class="item" @click="selectNum1(1)">
						<img class="select"
							:src="isSelect==1?'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/03/03/h7axstiyrczwpifo.png':'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/03/03/vyldlkroee0e7dkr.png'"
							alt="" />
						<div class="label">
							可推送生源 100人
						</div>
						<img class="up" src="../img/selectnum.png" alt="" />
					</div>
					<div class="xian">

					</div>
					<div class="item" @click="selectNum1(2)">
						<img class="select"
							:src="isSelect==2?'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/03/03/h7axstiyrczwpifo.png':'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/03/03/vyldlkroee0e7dkr.png'"
							alt="" />
						<div class="label">
							可推送生源 50人
						</div>
						<img class="up" src="../img/selectnum.png" alt="" />
					</div>
				</div>
			</div>


			<div class="messageType">
				<div class="title">
					选择职位
				</div>
				<div class="tabs">
					<div class="positionContainer" @click="jobDialogVisible = true">
						<div class="left">
							<img src="../img/selected.png" alt="" />
							<div class="" v-if="selectRow.job_name">
								{{selectRow.job_name+'·'+selectRow.salary+'·'+selectRow.education}}
							</div>
							<div class="" v-else>

							</div>
						</div>
						<div class="right">
							<img src="../img/change.png" alt="" />
							<div class="">
								换职位
							</div>
						</div>
					</div>

				</div>
			</div>

			<div class="screenContainer">
				<div class="screentitleContainer">
					<div class="title1">
						选择社区
					</div>
				</div>

				<div class="screen">
					<div class="item">
						<div class="left">
							高校社区
						</div>
						<div class="right teshu">
							<el-select v-model="academy_name" multiple filterable collapse-tags placeholder="请搜索并选择高校社区"
								style="width: 50px;">
								<el-option v-for="(item,index) in schoolList" :key="index" :label="item.academyName"
									:value="item.academyName">
								</el-option>
							</el-select>
						</div>
					</div>
					<div class="item">
						<div class="left">
							其他社区
						</div>
						<div class="right">
							<el-select v-model="is_just_chat" multiple collapse-tags placeholder="请选择其他社区">
								<el-option v-for="(item,index) in isCommunication" :key="index" :label="item.intr_name"
									:value="item.intr_name">
								</el-option>
							</el-select>
						</div>
					</div>

				</div>
			</div>
		</div>
		<div class="btnContainer">
			<!-- <el-button type="primary">公司预览</el-button> -->
			<el-button type="primary"  @click="submit">立即推送</el-button>
		</div>

		<el-dialog title="选择岗位" :visible.sync="jobDialogVisible" width="860px" :before-close="handleClose">
			<div class="jobSelect">
				<el-table :data="jobList"  border style="width: 100%" @row-click="rowClick" >
					<!-- <el-table-column prop="job_type" label="" width="50">
						<template slot-scope="scope">
							<div class="" style="display: flex;align-items: center;justify-content: center;">
								<img style="width: 20px;height: 20px;" src="../img/selected.png" alt=""
									v-if="scope.row.id==selectId" />
								<img style="width: 20px;height: 20px;" src="../img/select.png" alt="" v-else />
							</div>
						</template>
					</el-table-column> -->
					<el-table-column prop="job_type" label="类型">
						<template slot-scope="scope">
							<div class="one-line">
								{{ scope.row.job_type|jobType}}
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="job_name" label="职位名称" width="110">
					</el-table-column>
					<el-table-column prop="salary" label="薪资" width="110">
						<template slot-scope="scope">
							<div class="one-line">
								{{ scope.row.salary|salary}}
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="education" label="学历要求">
					</el-table-column>
					<el-table-column prop="job_num" label="招聘人数">
					</el-table-column>
					<el-table-column prop="work_time" label="工作时间" width="110">
					</el-table-column>
					<el-table-column prop="job_end_time" label="招聘截止时间" width="110">
					</el-table-column>
					
					<el-table-column  label="操作" width="110">
						<template slot-scope="scope" >
							<el-button class="compile" type="primary" @click="rowClick(scope.row)">选择</el-button>
							<!-- <el-button class="delete" type="danger" @click="delJob1(scope.row.id)">删除</el-button> -->
							<!-- <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
							<el-button type="text" size="small">编辑</el-button> -->
						</template>
					</el-table-column>
					
				</el-table>
			</div>
		</el-dialog>



	</div>
</template>
<script>
	import {
		mapMutations,
		mapState
	} from 'vuex'
	export default {
		data() {
			return {
				radio: '1',
				isSelect: 0,

				activeName: '0',
				textarea1: '',


				dialogImageUrl: '',
				dialogVisible: false,


				jobList: [],
				jobDialogVisible: false,
				currentRow: 0,


				selectId: 0,
				selectRow: {},

				residue: 0,
				total: 0,
				used: 0,

				majorList: [], //专业列表

				//学校层次
				intrdustry_10: [{
						intr_name: "双一流"
					},
					{
						intr_name: "C9"
					},
					{
						intr_name: "E9"
					},
					{
						intr_name: "985"
					},
					{
						intr_name: "211"
					},
					{
						intr_name: "国防七子"
					},
					{
						intr_name: "建筑老八校"
					},
					{
						intr_name: "建筑新八校"
					},
					{
						intr_name: "两电一邮"
					},
					{
						intr_name: "五院四系"
					},
					{
						intr_name: "八大美院"
					}
				],

				schoolList: [],
				eduList: ["大专", "本科", "硕士", "博士"],
				currentList: [{
						intr_name: "24届"
					},
					{
						intr_name: "25届"
					}
				],
				options: [{
					value: '1',
					label: '男'
				}, {
					value: '2',
					label: '女'
				}],
				
				

				isCommunication: [{
						intr_name: '考研'
					},
					{
						intr_name: '考公'
					},
					{
						intr_name: '考证'
					},
					{
						intr_name: '竞赛'
					},
					{
						intr_name: '实习'
					},
					{
						intr_name: '就业'
					},
					{
						intr_name: '创业'
					},
					{
						intr_name: '留学'
					},
					{
						intr_name: '专业能力'
					},
					{
						intr_name: '综合能力'
					},
				],
				
				
				intention: [{
						intr_name: "求职中"
					},
					{
						intr_name: "观望机会"
					}
				],
				cityList: [],

				academy_name: '', //学校

				// education: '', //学习阶段
				// city_name: '', //学校所在城市

				// academy_feature: '', //学校层次
				// major_name: '', //专业要求
				// is_current_year: '', //是否应届
				// gender: '', //性别
				is_just_chat: '', //近期是否聊过
				// job_status: '', //求职意向
				// work_city: '', //意向城市

				// fileList: [],
				// cover_video_url: '',

				selectNum: 200,
				jobTitle: '',
			};
		},
		computed: {
			...mapState({
				nextToken: state => state.nextToken,
				userInfo: state => state.userInfo,
				schoolInfo: state => state.schoolData,
			}),
		},
		mounted() {
			this.getmyJobList()
			this.getObjectCredit()

			// this.getcatalogall()
			// this.getCityList()

			this.remoteMethod()
			// this.$util.post(
			// 	"/login/login", {
			// 		username: this.ruleForm.username,
			// 		password: this.$md5(this.ruleForm.pass),
			// 	},
			// 	(res) => {
			// 		
			// 		if (res.code == 1) {
			// 			localStorage.setItem("token", res.data.token);
			// 			this.$router.push({
			// 				path: "/main",
			// 				// query: {
			// 				//   id: 1,
			// 				// },
			// 			});
			// 		}
			// 	}
			// );
		},
		filters: {
			jobType(val) {
				switch (val) {
					case 1:
						return '全职';
					case 2:
						return '实习';
					case 3:
						return '兼职';
					default:
						return '全职';
				}
			},
			salary(val) {
				if (val) {
					return val
				} else {
					return '面议'
				}
			}
		},
		methods: {
			...mapMutations(['setIslogin']),
			handleClick(tab, event) {
				
			},
			selectNum1(idx) {
				if (idx == 0) {
					this.selectNum = 200
				} else if (idx == 1) {
					this.selectNum = 100
				} else if (idx == 2) {
					this.selectNum = 50
				}
				this.isSelect = idx
			},
			submit() {
				if (this.jobList.length == 0) {
					this.$alert('请先添加职位', '提示', {
						confirmButtonText: '确定',
						callback: () => {

						}
					});
					return
				}


				let obj = {
					is_current_year: JSON.stringify(this.is_current_year),
					job_status: JSON.stringify(this.job_status),
					academy_feature: JSON.stringify(this.academy_feature),
					academy_name: JSON.stringify(this.academy_name),
					education: JSON.stringify(this.education),
					major_name: JSON.stringify(this.major_name),
					work_city: JSON.stringify(this.work_city),
					gender: JSON.stringify(this.gender),
					is_just_chat: JSON.stringify(this.is_just_chat),
					city_name: JSON.stringify(this.city_name),

					job_title: JSON.stringify([this.jobTitle]),
					// is_prepare: this.intrdustry_0.children[this.selectTypeIndex].salary_min,
					object_num: this.selectNum,
					admin_id: this.schoolInfo.admin_id,
					// message_json:JSON.stringify(this.JobJosn),
				}


				if (this.xzqf_object_credit < this.selectNum) {
					this.$confirm('您的额度不足，请联系13407188008（上班时间8:30~18:00）开通后续服务。', '额度不足', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					});
					return
				}
				this.$confirm(`您确定推送${this.selectNum}生源吗？`, '确认推送', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					
					this.$util.post(
						"v2/school_job/batch_send", {
							...obj
						},
						(res) => {
							
							this.getObjectCredit()
						})
				}).catch(() => {
					
				});
				// this.$confirm(`您确定推送${this.selectNum}生源吗？`, '确认推送', {
				// 	confirmButtonText: '确定',
				// 	cancelButtonText: '取消',
				// 	type: 'warning',
				// 	then: () => {
				// 		

				// 	}
				// });

			},
			//获取学校列表
			remoteMethod() {
				this.$util.post(
					"v2/academy/academyService/pageListNew", {
						province:'湖北',
						max_score: 750,
						min_score: 200,
						size:99999,
					},
					(res) => {
						
						if (res.code == 200) {
							// let keyList = Object.keys(res.data)
							// let arr = []
							// keyList.forEach((item) => {
							// 	arr.push(...res.data[item])
							// })
							// 
							this.schoolList = res.data.data
							// return arr
						} else {
							this.schoolList = []
						}
					}
				);
			},
			handleRemove(file, fileList) {
				
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
			handleClose(done) {
				done();
			},
			getmyJobList() {
				this.$util.post(
					"v2/school_job/my_job_list", {
						admin_id: this.schoolInfo.admin_id,
						id: this.schoolInfo.id,
						page: this.currentpage,
						size: 100,
					},
					(res) => {
						
						if (res.code == 200) {
							
							let list = res.data.data
							list.map((item, index, arr) => {
								if (item.education === '不限') {
									arr[index].education = '学历不限'
								}
							})
							this.jobList = list
							this.selectRow = list[0]
							this.jobTitle = list[0].job_title
							// let arr = []
							// res.data.data.forEach((item)=>{

							// })

						}
					}
				);
			},
			getObjectCredit() {
				this.$util.post(
					"v2/school_job/get_object_credit", {
						admin_id: this.schoolInfo.admin_id,
					},
					(res) => {
						
						if (res.code == 200) {
							
							// xzqf_object_credit//剩余
							// xzqf_total_object_credit//总数
							this.residue = res.data.xzqf_object_credit
							this.total = res.data.xzqf_total_object_credit
							this.used = res.data.xzqf_total_object_credit - res.data.xzqf_object_credit
						}
					}
				);
			},
			//获取专业列表
			getcatalogall() {
				this.$util.post(
					"v2/major/getcatalogall", {
						type_code: '0',
						user_id: 0,
					},
					(res) => {
						
						if (res.code == 0) {
							
							let arr = []
							res.data.forEach((item) => {
								if (item.majors) {
									arr.push(...item.majors)
								}
							})
							
							this.majorList = arr
							

						}
					}
				);
			},
			//获取城市列表
			getCityList() {
				this.$util.get1(
					"https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2023/06/25/list_citys.json?0.17568012768125008", {},
					(res) => {
						
						let keyList = Object.keys(res)
						let arr = []
						keyList.forEach((item) => {
							arr.push(...res[item])
						})
						this.cityList = arr
					}
				);
			},
			rowClick(row) {
				
				this.selectId = row.id
				this.selectRow = row
				this.jobTitle = row.job_title
				this.jobDialogVisible = false
			},
			handleAvatarSuccess3(response, file, fileList) {
				
				
				
				// [{url:'',id:0}]
				this.fileList = fileList
			},
			handleAvatarSuccess4(res) {
				this.cover_video_url = res.data.fileUrl;
			},

			beforeAvatarUpload(file) {
				
				const isJPG = file.type === 'image/jpeg';
				const isPNG = file.type === 'image/png';
				const isLt2M = file.size / 1024 / 1024 < 10;
				let img = isJPG || isPNG
				if (!isJPG && !isPNG) {
					this.$message.error('上传图片格式错误!');
					return
				}
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 10MB!');
					return
				}
				
				return isLt2M && img;
			},

		},
	};
</script>
<style>
	#pushMessage .el-tabs__nav-wrap::after {
		border: none !important;
	}

	#pushMessage .el-tabs__active-bar {
		background: #F34B00;
	}

	#pushMessage .el-tabs__item.is-active {
		color: #000000;
	}

	#pushMessage .el-tabs__item {
		color: #6B6A6A;
	}

	#pushMessage .el-textarea__inner {
		border: none;
		resize: none !important;
	}

	/* #pushMessage .screen .el-input__inner {
		border: none !important;
		text-align: left !important;
		background: initial !important;
		font-size: 16px !important;
	} */

	#pushMessage .screen .el-select__input {
		border: none !important;
		text-align: left !important;
		background: initial !important;
		font-size: 16px !important;
	}

	#pushMessage .screen .el-select {
		flex: 1;
	}

	#pushMessage .screen .el-select__tags {
		justify-content: flex-end;
	}

	/* #pushMessage .screen .el-tag.el-tag--info {
		background-color: #ecf5ff;
		border-color: #d9ecff;
		color: #409EFF;
	} */

	/* #pushMessage .screen .teshu .el-select__input {
		width: 50px !important;
		flex-grow: initial !important;
	} */
</style>
<style lang="less" scoped>
	.container {
		width: 100%;
		padding: 0 40px;
		margin-bottom: 50px;

		.titleContainer {
			width: 100%;
			border-bottom: 1px solid #EEEEEE;
			padding: 20px 0 20px 0;
			position: relative;

			.title1 {
				font-weight: 500;
				font-size: 16px;
				color: #2D3C50;
				margin-bottom: 20px;
			}

			.title2 {
				font-weight: 500;
				font-size: 14px;
				color: #484848;
			}

			.xian {
				position: absolute;
				bottom: 0;
				left: 0;
				width: 45px;
				height: 5px;

				background: #87ADF4;
				border-radius: 2px;

			}
		}
	}

	.sourceStudents {
		padding: 0 24px;
		min-width: 791px;

		.sourceStudentsNum {
			display: flex;
			align-items: center;
			margin-bottom: 25px;

			.num1 {
				width: 369px;
				height: 104px;
				background: url(../img/bg2.png);
				background-repeat: no-repeat;
				background-size: 369px 104px;
				margin-right: 5px;
				padding: 20px;

				.title {
					font-weight: 500;
					font-size: 16px;
					color: #FEF6F2;
					margin-bottom: 10px;
				}

				.numContainer {
					display: flex;
					align-items: baseline;
					justify-content: center;

					.num {
						// font-weight: bold;
						font-size: 26px;
						color: #FFFFFF;
						margin-right: 10px;
					}

					.unit {
						// font-weight: bold;
						font-size: 16px;
						color: #FFFFFF;
					}

				}

			}

			.num2 {
				width: 369px;
				height: 104px;
				background: url(../img/bg1.png);
				background-repeat: no-repeat;
				background-size: 369px 104px;
				padding: 20px;

				.title {
					font-weight: 500;
					font-size: 14px;
					color: #FEF6F2;
					margin-bottom: 10px;
				}

				.numContainer {
					display: flex;
					align-items: baseline;
					justify-content: center;

					.num {
						// font-weight: bold;
						font-size: 26px;
						color: #FFFFFF;
						margin-right: 10px;
					}

					.unit {
						// font-weight: bold;
						font-size: 16px;
						color: #FFFFFF;

					}


				}

			}
		}

		.selectnum {
			min-width: 745px;
			margin-bottom: 25px;

			.title {
				margin-bottom: 25px;
				
				// font-weight: bold;
				font-size: 16px;
				color: #000000;
			}

			.selectnumMain {
				width: 745px;
				background: #F6F7FB;
				border-radius: 10px;
				display: flex;
				align-items: center;

				justify-content: space-between;
				padding: 40px 20px;

				.item {
					display: flex;
					align-items: center;
					font-size: 0;
					cursor: pointer;

					.select {
						width: 20px;
						height: 20px;
						margin-right: 10px;
						cursor: pointer;
					}

					.label {
						font-weight: 500;
						font-size: 14px;
						color: #000000;
					}

					.up {
						width: 18px;
						height: 18px;
					}

				}

				.xian {
					height: 12px;
					border-left: 1px solid #D2D2D2;
				}
			}
		}

		.messageType {
			min-width: 745px;

			.title {
				margin-bottom: 25px;
				
				// font-weight: bold;
				font-size: 16px;
				color: #000000;
			}

			.tabs {
				margin-bottom: 40px;

				.positionContainer {
					background: #F6F7FB;
					border-radius: 10px;
					width: 745px;
					cursor: pointer;
					display: flex;
					align-items: center;
					justify-content: space-between;
					padding: 40px 20px;

					.left {
						margin-right: 5px;
						font-size: 0;
						display: flex;
						align-items: center;

						img {
							width: 20px;
							height: 20px;
							margin-right: 8px;
						}

						div {
							font-weight: 500;
							font-size: 14px;
							color: #000000;
						}
					}

					.right {
						font-size: 0;
						display: flex;
						align-items: center;

						img {
							width: 13px;
							height: 16px;
							margin-right: 8px;
						}

						div {
							font-weight: 500;
							font-size: 14px;
							color: #000000;
						}
					}
				}

				.imageText {
					width: 745px;
					background: #F6F7FB;
					border-radius: 10px;
					padding: 30px 25px;

					.textContainer {
						margin-bottom: 30px;

						.textTitle {
							font-weight: 400;
							font-size: 14px;
							color: #000000;
							margin-bottom: 10px;
							margin-bottom: 10px;
						}

						.text {
							background: #FFFFFF;
							border-radius: 10px;
							border: 1px solid #E5E5E5;
							display: flex;
							// align-items: center;
							justify-content: space-between;
							font-size: 0;
							padding: 20px;

							img {
								width: 20px;
								height: 20px;
							}
						}

					}

					.imgContainer {
						.imgTitle {
							font-weight: 400;
							font-size: 14px;
							color: #000000;
							margin-bottom: 10px;
							margin-bottom: 10px;
						}

						.img {
							background: #FFFFFF;
							border-radius: 10px;
							border: 1px solid #E5E5E5;
							display: flex;
							// align-items: center;
							justify-content: space-between;
							font-size: 0;
							padding: 20px;

							.uplodaImg {
								width: 20px;
								height: 20px;
							}
						}
					}

				}

			}
		}

		.screenContainer {
			min-width: 745px;

			.screentitleContainer {
				display: flex;
				align-items: baseline;
				margin-bottom: 17px;

				.title1 {
					
					// font-weight: bold;
					font-size: 16px;
					color: #000000;
					margin-right: 14px;
				}

				.title2 {
					font-weight: 400;
					font-size: 16px;
					color: #8F8F8F;
				}
			}

			.screen {
				max-width: 745px;
				display: grid;
				// grid-template-columns: repeat(2, 370px);
				grid-gap: 20px 25px;

				margin-bottom: 20px;

				.item {
					// width: 370px;
					padding: 15px 20px;
					display: flex;
					align-items: center;
					justify-content: space-between;

					background: #F6F7FB;
					border-radius: 10px;
					font-size: 0;

					.left {
						font-weight: 500;
						font-size: 14px;
						color: #0A0A0A;
						margin-right: 20px;
						width: 425px;
					}

					.right {
						flex: 1;
						display: flex;
						align-items: center;
						font-size: 0;

						div {
							font-weight: 500;
							font-size: 16px;
							color: #999999;
						}

						img {
							width: 12px;
							height: 12px;
						}
					}

				}
			}
		}
	}

	.btnContainer {
		width: 770px;
		display: flex;
		justify-content: flex-end;
		margin-bottom: 60px;

		.el-button--primary {
			// background-color: #0084FF !important;
			// border-color: #0084FF !important;
			// border-radius: 10px !important;
		}
	}

	.jobSelect {}

	#pushMessage {
		.avatar-uploader-icon {
			font-size: 28px;
			color: #8c939d;
			width: 148px;
			height: 148px;
			line-height: 148px;
			text-align: center;
			background-color: #fbfdff;
			border: 1px dashed #c0ccda;
		}
	}
	
	.companyInfo {
		width: 100%;
		padding: 20px 0 20px 0;
		border-bottom: 1px solid #EEEEEE;
		font-size: 0;
		display: flex;
		align-items: center;
		// margin-bottom: 5px;
	
		// img {
		// 	width: 57px;
		// 	height: 57px;
		// 	border-radius: 50%;
		// 	background: #003987;
		// 	margin-right: 10px;
		// }
	
		.companyInfoRight {
			display: flex;
			justify-content: center;
			flex-direction: column;
	
			.companyInfoName {
				font-weight: 500;
				font-size: 18px;
				color: #2D3C50;
				margin-bottom: 10px;
			}
	
			.tags {
				display: flex;
				align-items: center;
	
				.item {
					padding: 2px 4px;
					border-radius: 5px;
					border: 1px solid #AEAEAE;
					font-weight: 500;
					font-size: 12px;
					color: #AEAEAE;
					margin-right: 5px;
				}
			}
		}
	}
</style>